<template>
  <button class="group flex items-center gap-3 text-sm font-medium text-theme-1" @click="toggle">
    <div
      class="flex h-10 w-10 items-center justify-center rounded-full bg-light-blue transition-all duration-200 ease-in-out group-hover:bg-theme-5"
    >
      <img
        :src="isVisible ? Icons.Minus.src : Icons.Plus.src"
        class="flex h-full w-full transform items-center justify-center text-3xl text-theme-1 transition-all duration-200 ease-in-out group-hover:text-white"
        :class="{ 'rotate-90': !isVisible, 'rotate-0': isVisible }"
      />
    </div>

    <span class="text-base font-medium">
      {{ $t(isVisible ? "pages.profile-shop.compare-style.hide" : "pages.profile-shop.compare-style.show") }}
    </span>
  </button>
</template>

<script setup lang="ts">
import { Icons } from "@/core-ui-vue";

const isVisible = defineModel<boolean>({ required: true });

function toggle() {
  isVisible.value = !isVisible.value;
}
</script>

<style scoped>
.transform {
  transition: transform 0.2s ease-in-out;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
